var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('router-link',{attrs:{"to":{name: 'ChangePasswordView'}}},[_vm._v("Vaihda salasanaa")]),_vm._v(" "),(this.loggedIn())?_c('button',{on:{"click":function($event){_vm.logout()}}},[_vm._v("Kirjaudu ulos")]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d68dd5e6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/UserInfoView.vue
// module id = null
// module chunks = 